import { useThemeToggle } from '../contexts/ThemeContext';
import { useIsManualPreview } from '../contexts/ManualPreviewContext';
import { getManualPalette, getPreviewPalette } from '../components/Manual/manualPalette';

export default function useManualPalette() {
  const { mode } = useThemeToggle();
  const isPreview = useIsManualPreview();
  return isPreview ? getPreviewPalette() : getManualPalette(mode);
}